import React, { Component } from 'react'
import { MobileTimePicker } from '@mui/x-date-pickers'
import moment from 'moment'
import { MdCheckBox, MdCheckBoxOutlineBlank } from 'react-icons/md'

class Tabella extends Component {
  constructor (props) {
    super(props)
    this.state = {
      hours: null,
      year: new Date().getFullYear(),
      month: moment(new Date()).month()
    }
  }

  render () {
    const { hours, dayHeaders } = this.props

    const convertTimeStringToMoment = (timeString) => {
      return moment(timeString, 'HH:mm')
    }

    return (
      <table className='fixed-table' style={{ display: (hours && hours.length > 0) ? 'block' : 'none' }}>
        <thead>
          <tr>
            <td className='fixed-column'>BAMBINO</td>
            {dayHeaders && dayHeaders.map((day, j) => (
              <td key={`head_${j}`} className='scrollable-columns title'>{day}</td>
            ))}
            <td className='fixed-last-column'>TOTALE</td>
          </tr>
        </thead>
        <tbody>
          {hours && hours.length > 0 && hours.map((row, k) => (
            <tr key={`row_${k}`}>
              <td className='fixed-column'>{row.childName}</td>
              {
                row && row.days && row.days.length > 0 && row.days.map((day, i) => {
                  return (
                    day
                      ? (
                        <td key={`col_${i}`} className='scrollable-columns'>
                          <div className='hourconvalidated' style={{ display: day.convalidated ? 'flex' : 'none' }} />
                          <div className='cellcontainer'>
                            {day.present && <div className='tilemeal green' onClick={async () => await this.props.updateHours(day._id, day.date, day.entrance, day.exit, day.meal, false)}><MdCheckBox /><span>Presente</span></div>}
                            {!day.present && <div className='tilemeal red' onClick={async () => await this.props.updateHours(day._id, day.date, day.entrance, day.exit, day.meal, true)}><MdCheckBoxOutlineBlank /><span>Assente</span></div>}

                            <div className='hourdetail' style={{ display: day.present ? 'flex' : 'none' }}>
                              <div className='hourclock'>
                                <MobileTimePicker
                                  className='timepicker'
                                  openTo='hours'
                                  ampm={false}
                                  value={convertTimeStringToMoment(day.entrance)}
                                  onChange={async e => await this.props.updateHours(day._id, day.date, moment(e).format('HH:mm'), day.exit, day.meal, day.present)}
                                />
                              </div>
                              <div className='hourclock' style={{ marginLeft: 10 }}>
                                <MobileTimePicker
                                  className='timepicker'
                                  openTo='hours'
                                  ampm={false}
                                  value={convertTimeStringToMoment(day.exit)}
                                  onChange={async e => await this.props.updateHours(day._id, day.date, day.exit, moment(e).format('HH:mm'), day.meal, day.present)}
                                />
                              </div>
                            </div>

                            {day.meal && day.present && <div className='tilemeal' onClick={async () => await this.props.updateHours(day._id, day.date, day.entrance, day.exit, false, day.present)}><MdCheckBox /><span>Pasto</span></div>}
                            {!day.meal && day.present && <div className='tilemeal' onClick={async () => await this.props.updateHours(day._id, day.date, day.entrance, day.exit, true, day.present)}><MdCheckBoxOutlineBlank /><span>Pasto</span></div>}
                          </div>
                        </td>
                        )
                      : <td key={`col_${i}`} className='scrollable-columns'>Nessun ingresso</td>
                  )
                })
              }
              <td className='fixed-last-column'>
                <div className='orepasti'>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <span>Ore: <b>{row.totalHours.toString().length === 1 ? '0' + row.totalHours : row.totalHours}:{row.totalMinutes.toString().length === 1 ? '0' + row.totalMinutes : row.totalMinutes}</b></span>
                    {row.payment && <span className='labelgreen'>({row.payment ? (row.payment.priceSconto ? (row.payment.hours - row.payment.priceSconto) : row.payment.hours) : ''}€)</span>}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <span>Pasti: <b>{row.meals}</b></span>
                    {row.payment && <span className='labelgreen'>({row.payment ? row.payment.meal : ''}€)</span>}
                  </div>
                  <div
                    className='btnrilascia'
                    style={{ backgroundColor: !row.payment ? '#DA7297' : row.payment.status === 'pagamento' ? '#DA7297' : (row.payment.status === 'inviato' ? '#ebb734' : (row.payment.status === 'fatturato' ? '#ff6600' : (row.payment.status === 'incassato' ? '#16a622' : '#DA7297'))) }}
                    onClick={async () => await this.props.showModal(row)}
                  >
                    {!row.payment && <span>Pagamento</span>}
                    {row.payment && <span>{row.payment.status === 'pagamento' ? 'Pagamento' : (row.payment.status === 'inviato' ? 'Inviato' : (row.payment.status === 'fatturato' ? 'Fatturato' : 'Incassato'))}</span>}
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}

export default Tabella
